import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'wx-delete-confirm-icon',
  templateUrl: './delete-confirm-icon.component.html',
  styleUrls: ['./delete-confirm-icon.component.scss']
})
export class DeleteConfirmIconComponent implements OnInit {

  constructor() { }

  @Output() confirm = new EventEmitter();
  
  ngOnInit(): void {
  }

}
